import { ChangeDetectionStrategy, Component, computed, CUSTOM_ELEMENTS_SCHEMA, effect, ElementRef, input, viewChild } from '@angular/core';
import { SwiperOptions } from 'swiper/types/swiper-options';
import { A11y, Keyboard, Navigation, Pagination } from 'swiper/modules';
import { TranslatePipe } from '@ngx-translate/core';
import { SwiperContainer } from 'swiper/element';

const DEFAULT_SWIPER_OPTIONS: SwiperOptions = {
  direction: 'horizontal',
  modules: [Pagination, Navigation, A11y, Keyboard],
  slidesPerView: 2.2,
  a11y: {
    enabled: true,
  },
  keyboard: true,
  watchOverflow: true,
  initialSlide: 0,
  spaceBetween: 20,
  touchEventsTarget: 'container',
  breakpoints: {
    992: {
      slidesPerView: 2.2,
    },
    850: {
      spaceBetween: 30,
      slidesPerView: 2,
    },
    650: {
      slidesPerView: 1.8,
    },
    500: {
      slidesPerView: 1.4,
    },
    400: {
      slidesPerView: 1.1,
    },
    0: {
      slidesPerView: 1,
    },
  },
};

@Component({
  selector: 'mwe-horizontal-swiper',
  templateUrl: './horizontal-swiper.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslatePipe],
  schemas: [CUSTOM_ELEMENTS_SCHEMA], //needed for swiper webcomponents
})
export class HorizontalSwiperComponent {
  swiper = viewChild<ElementRef<SwiperContainer>>('swiper');
  nextButton = viewChild<ElementRef<HTMLButtonElement>>('nextButton');
  prevButton = viewChild<ElementRef<HTMLButtonElement>>('prevButton');
  additionalOptions = input<SwiperOptions>({});

  options = computed<SwiperOptions>(() => ({
    ...DEFAULT_SWIPER_OPTIONS,
    ...this.additionalOptions(),
  }));

  constructor() {
    effect(() => {
      const el = this.swiper()?.nativeElement;
      const prev = this.prevButton().nativeElement;
      const next = this.nextButton().nativeElement;

      Object.assign(el, {
        ...this.options(),
        navigation: {
          prevEl: prev,
          nextEl: next,
        },
      });

      el.initialize?.();
    });
  }
}
